import { Button, Modal } from 'antd'
import { FC, useEffect, useState } from 'react'
import Loading from '../elements/loading/Loading'
import { getPayStatus } from '../../shared/http/purchases'
import { goToPageNotPremium } from '../utils/goToPage'
import { NavigationPages } from '../../common/navigation/navigation-pages'
import { useNavigate } from 'react-router-dom'
import Link from 'antd/es/typography/Link'
import useInterval from 'use-interval'
import { fetchCommunities } from '../../store/communities/extraReducers'

interface LoginCodeDialogProps {

    closeDialog: () => void,
    open: boolean;
    paymentId?: number,
    payLink?: string
}

const CoursePayLoadingDialog: FC<LoginCodeDialogProps> = ({ closeDialog, open, paymentId, payLink }) => {

    const navigate = useNavigate()
    const POLLING_INTERVAL = 5000 // Poll every 5 seconds

    const [status, setStatus] = useState<string | undefined>(undefined)
    const [isRunning, setIsRunning] = useState(false)

    useInterval(() => {
        // Your custom logic here
        fetchData()
    }, isRunning ? POLLING_INTERVAL : null)

    const close = () => {
        setIsRunning(false)
        closeDialog()
    }

    useEffect(() => {
        if (open) {
            setIsRunning(true)
        }
    }, [paymentId, open])


    const fetchData = () => {
        getPayStatus(paymentId!).then(resp => {
            if (resp.data.status === 'SUCCEEDED') {
                setIsRunning(false)
                close()
                goToPageNotPremium(`${NavigationPages.COURSES}/` + resp.data.courseId, navigate)
            }
        })
    }

    return (
        <Modal title='Ожидание оплаты'
               onCancel={close}
               footer={[
                   <Button key='submit' onClick={close}>
                       Отмена
                   </Button>,
                   <Button key='submit' onClick={close}>
                       Ok
                   </Button>

               ]}
               open={open}>
            {payLink && <Link href={payLink}>Ссылка на оплату</Link>}
            <Loading />
        </Modal>
    )
}

export default CoursePayLoadingDialog